// Angular
import { Component, OnInit } from '@angular/core';
// Models
// import { Post } from './../../models/post';
// External
import { AngularFireDatabase } from 'angularfire2/database';
import * as moment from 'moment';
import * as lodash from 'lodash';
import { DatePipe } from '@angular/common';
import { ApiService } from './../../services/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { OAuthService } from './../../services/o-auth';
import { Order } from './../../models/order'
import { AngularFireAuth } from 'angularfire2/auth';
import { FirebaseApp } from 'angularfire2';
import { Http, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';

@Component({
    templateUrl: './leagues.component.html'
})
export class LeaguesComponent implements OnInit {
    public leagues: Array<any>
    constructor(public sanitizer: DomSanitizer, private fireDatabase: AngularFireDatabase, private firebase: FirebaseApp, private datePipe: DatePipe,
        private oAuthService: OAuthService, private apiService: ApiService, private fireAuth: AngularFireAuth, private http: Http) {


    }
    ngOnInit() {

        this.apiService.list("leagues").then((res) => {
            this.leagues = []
            for (let i = 0; i < res.length; i++) {
             res[i].tournamentCount = Object.keys(res[i].tournaments).length
             this.leagues.push(res[i])   
            }
        })
    }



}

